import moment from 'moment-timezone';
import { getTimeFromUTCOffset } from './calculateFutureDatedOrderingWindow';

export const getStoreLocalMoment = (
  time: string | undefined,
  utcOffset: number | undefined,
) => {
  if (!time) {
    return undefined;
  }

  if (utcOffset) {
    return moment(time).utcOffset(getTimeFromUTCOffset(utcOffset));
  }

  // No separately-known store offset - trust the offset already embedded
  // in the time string itself, rather than guessing based on whichever
  // device happens to be viewing it.
  return moment.parseZone(time);
};
